import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageMaintenanceComponent } from './shared/components/page-maintenance/page-maintenance.component';
import { MaintenanceGuard } from './core/services/maintenance.guard';

import { AppComponent } from './app.component';
import { ErreurComponent } from './erreur/erreur.component';
import { StartComponent } from './api/start/start.component';

const routes: Routes = [
  // Always accessible
  { path: 'page-maintenance', component: PageMaintenanceComponent },

  // All other routes guarded by maintenance
  {
    path: '',
    canActivate: [MaintenanceGuard],
    children: [
      { path: '', redirectTo: '/salesforce', pathMatch: 'full' },

      {
        path: 'standalone',
        // loadChildren: () => import('./standalone/standalone-routing.module').then(m => m.StandaloneRoutingModule),
        loadChildren: () => import('./standalone/standalone.module').then(m => m.StandaloneModule),
    
      },
      {
        path: 'salesforce',
        loadChildren: () => import('./salesforce/salesforce-routing.module').then(m => m.SalesforceRoutingModule),
      },
    
      {
        path: 'administration',
        // loadChildren: () => import('./administration/administration-routing.module').then(m => m.AdministrationRoutingModule),
        loadChildren: () => import('./administration/administration.module').then(m => m.AdministrationModule),
      },
    
      {
        path: 'eloqua',
        loadChildren: () => import('./eloqua/eloqua-routing.module').then(m => m.EloquaRoutingModule),
      },
    
      // Only For testing purpose
      {
        path: 'campagne',
        loadChildren: () => import('./campagne/campagne-routing.module').then(m => m.CampagneRoutingModule),
      },
    
      // A réorganiser
      { path: 'api/start', component: StartComponent },
    
      { path: 'erreur', component: ErreurComponent },
    ]
  },

  // Fallback
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
